"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var styles_module_scss_1 = __importDefault(require("./styles.module.scss"));
var next_intl_1 = require("next-intl");
var swr_hooks_1 = require("@l2p/swr-hooks");
var Switcher = function () {
    var t = (0, next_intl_1.useTranslations)('translation');
    var _a = (0, swr_hooks_1.useSwitchPaymentType)(), paymentType = _a.paymentType, changePaymentType = _a.changePaymentType;
    return (react_1.default.createElement("div", { className: styles_module_scss_1.default.container },
        react_1.default.createElement("div", { className: "".concat(styles_module_scss_1.default.button, " ").concat(paymentType === swr_hooks_1.PAYMENT_TYPES.DEPOSIT ? styles_module_scss_1.default.active : ''), onClick: function () {
                changePaymentType(swr_hooks_1.PAYMENT_TYPES.DEPOSIT);
            } },
            react_1.default.createElement("span", null, t('deposit'))),
        react_1.default.createElement("div", { className: "".concat(styles_module_scss_1.default.button, " ").concat(paymentType === swr_hooks_1.PAYMENT_TYPES.WITHDRAWAL ? styles_module_scss_1.default.active : ''), onClick: function () {
                changePaymentType(swr_hooks_1.PAYMENT_TYPES.WITHDRAWAL);
            } },
            react_1.default.createElement("span", null, t('withdrawal')))));
};
exports.default = Switcher;
